import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { timeout } from 'q';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = { menu: [] };

  }

  loadData = async () => {
    const response = await fetch('https://speedfoodrn.firebaseio.com/order.json')
    const data = await response.json()
    console.log(data)
    const ardata = Object.keys(data).map((key) => data[key])
    console.log(ardata)
    this.setState({ menu: ardata });
  }

  async componentDidMount() {
    await this.loadData();
  }

  render() {
    console.log(this.state.menu)
    return (
      <div className="App" >
        {this.state.menu.map((order) => {
          return <div style={{display:'inline-block',margin:20,  border:'1px solid gray', width:'340px',}}>
            <div style={{backgroundColor:'#4ddbff',height:'24px',paddingTop:'5px'}}>{order.orderName} : {order.orderContact}
            <button style={{float:'right',marginRight:5}}>รับออเดอร์</button>
            </div>
            <div>
              <table style={{width:'100%'}}>
                <thead style={{border:'1px solid gray' }}>
                  <tr style={{backgroundColor:'#b3f0ff'}}>
                    <th>รหัส</th>
                    <th>รายการ</th>
                    <th>ราคา</th>
                    <th>จำนวน</th>
                    <th>รวม</th>
                  </tr>
                </thead>
                <tbody>
                  {order.orderMenu.map((item) => {
                    return <tr>
                      <td>{item.key}</td>
                      <td style={{textAlign:'left',width:'120px'}}>{item.title}</td>
                      <td style={{textAlign:'right'}}>{item.price}</td>
                      <td style={{textAlign:'right'}}>{item.qty}</td>
                      <td style={{textAlign:'right'}}>{item.price * item.qty}</td>
                    </tr>
                  })}
                  <tr style={{backgroundColor:'#b3f0ff', height:30}}>
                      
                      <td colSpan='4'>รวมทั้งหมด</td>
                      <td style={{textAlign:'right'}}>{order.orderTotal}</td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        })}
      </div>
    );
  }
}

export default App;
